module.exports = __webpack_public_path__ + "img/manavis_festa2026.80bc484c.jpg";